export default __webpack_public_path__ + "static/media/Step 10 Image.ec77f357.png";